import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { M_UserDetailsApi, UserDetailsApi } from "../services/Api";
import { isAuthenticated, logout } from "../services/Auth";
import { useNavigate } from "react-router-dom";

export default function UserDropDown() {
    const navigate = useNavigate();
    const [user, setUser] = useState({ fullName: "", email: "", localId: "", role: "" });

    useEffect(() => {
        if (isAuthenticated()) {

            async function api() {
                try {
                    let response = await UserDetailsApi();
                    setUser(values => ({
                        ...values,
                        localId: response.data.users[0].localId

                    }))
                } catch (err) {
                    console.log(err)
                    if (err.response.data.error.message === "INVALID_ID_TOKEN") {
                        logout();
                        navigate('/login');
                    }
                }
            }
            api();
        }
    }, [navigate])


    useEffect(() => {
        if (isAuthenticated() && user.localId) {
            M_UserDetailsApi(user.localId).then((response) => {
                setUser(values => ({
                    ...values,
                    fullName: response.data.user[0].fullName,
                    email: response.data.user[0].email,
                    role: response.data.user[0].role
                }));
            })
        }
    }, [user.localId])

    return (
        <>
            <div className="dropdown m-3">

                <a className="nav-link dropdown-toggle" href="www.google.com" role="button"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <i className="fa-solid fa-user fa-lg"></i><span className="h6 m-1">User</span>

                </a>
                <ul className="dropdown-menu">

                    <li><Link to={"/profile"} className="dropdown-item border border-2 fw-medium">{user.fullName}</Link>
                    </li>

                    <li><Link className="dropdown-item" to={"/profile"}>
                        <i className="fa-regular fa-id-card"></i><span className="h6 m-2">Profile</span></Link>
                    </li>

                    <li>
                        <Link className="dropdown-item" to={"/bookingslot"}>
                            <i className="fa-solid fa-door-open fa-beat-fade" style={{ color: "#df6311" }}></i><span className="h6 m-2">Booking Slot</span>
                        </Link>
                    </li>

                    {user.role === 'admin' ? <li><Link className="dropdown-item" to={'/admin'}><i className="fa-solid fa-bars-progress fa-fade"></i><span className="h6 m-2">Dashboard</span></Link></li> : null}

                    <li><Link className="dropdown-item fw-medium" to={'/bookingdetails'}><i className="fa-solid fa-people-roof fa-beat-fade me-2" style={{ color: "#63E6BE" }}></i>Bookings</Link>
                    </li>
                    <li>
                        <hr className="dropdown-divider" />
                    </li>
                    <li><a className="dropdown-item me-2" href="https://wa.me/919022690226?text=Hi" target="_blank" rel="noreferrer"><i
                        className="fa-brands fa-square-whatsapp fa-shake fa-2xl me-2" style={{ color: "#25d366" }}></i><span className="h6 ms-1">Chat</span></a></li>
                </ul>
            </div>
        </>
    )
}
